export const createSlackConnectRequest = (code, redirectUri) => {
  return {
    url: "/orgs/slack/connect",
    method: "POST",
    data: { code, redirect_uri: redirectUri },
  };
};

export const createSlackStatusRequest = () => {
  return {
    url: "/orgs/slack/status",
    method: "GET",
  };
};

export const createSlackUpdateSettingsRequest = (notificationPreferences) => {
  return {
    url: "/orgs/slack/settings",
    method: "PUT",
    data: { notification_preferences: notificationPreferences },
  };
};

export const createSlackDisconnectRequest = () => {
  return {
    url: "/orgs/slack/disconnect",
    method: "DELETE",
  };
};
